module.exports = __webpack_public_path__ + "img/visitor-management.d3e04439.svg";